export type EmptySearchPrompt =
  | 'missing-api-key'
  | 'api-key-just-added'
  | 'no-results';

interface EmptySearchPromptInput {
  hasSearched: boolean;
  apiKeyPresent: boolean;
  promptedForApiKey: boolean;
}

/** Which empty-results message to show after a finished search with zero hits. */
export function resolveEmptySearchPrompt({
  hasSearched,
  apiKeyPresent,
  promptedForApiKey,
}: EmptySearchPromptInput): EmptySearchPrompt {
  if (hasSearched && !apiKeyPresent) {
    return 'missing-api-key';
  }
  if (hasSearched && apiKeyPresent && promptedForApiKey) {
    return 'api-key-just-added';
  }
  return 'no-results';
}
